import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getCompetencyListLoading: true, data: '', error: false };

export function competencyListDataReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_COMPETENCY_LIST:
            return {
                getCompetencyListLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_COMPETENCY_LIST:
            return {
                getCompetencyListLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_COMPETENCY_LIST:
            return {
                getCompetencyListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/competencyList.reducer.js